<div class="incorrect-login-container">
  <div class="incorrect-text" i18n="@@global.not-logged-right-account">
    Oops... Looks like you're not logged in with the right account
  </div>
  <div class="logout-container">
    <span class="logout-btn" i18n="@@global.log-out" (click)="onLogout()"
      >Log out</span
    >
    <img src="/assets/media/error/back-pain-man.png" alt="Back Pain Man" />
  </div>
</div>
